import React from "react";
import { View, Pressable, Image, ScrollView } from "react-native";
import { getImagePath } from "../../services/CommonUtils";

import { ScreenRoute } from "../../constants/ScreenRouteConstant";

import AppTheme from "../../../AppTheme";

const OrderImageListView = (props) => {
    const marginTop = props?.marginTop ?? 0
    const imageList = props.imageList ?? []
    const removeImageFromList = props?.removeImageFromList

    const previewOrderImages = (imageList, index) => {
        var imageUrlList = []
        imageList.forEach((image, i) => {
            imageUrlList.push({ imageUrl: image['imageUrl'] ?? image['imageURL'] })
        })
        props.navigation.navigate(ScreenRoute.images_preview,
            { imageList: imageUrlList, startIndex: index })
    }

    return (<ScrollView horizontal showsHorizontalScrollIndicator={false}
        style={{ paddingHorizontal: 16, width: AppTheme.appWidth, marginTop: marginTop }}>
        {!!imageList.length && imageList.map((image, index) =>
            <View style={{ marginRight: 16 }} key={index}>
                {!!removeImageFromList && <Pressable onPress={() => removeImageFromList(index)}
                    style={{
                        width: 14, height: 14, backgroundColor: '#fff', position: 'relative',
                        top: 8, zIndex: 1, right: -75, borderRadius: 50
                    }} onLongPress={() => { console.log('### long press') }}>
                    <Image source={{ uri: getImagePath('/images/icons/cancel_red_circle.svg') }}
                        style={{ width: 14, height: 14, borderRadius: 50 }} />
                </Pressable>}
                <Pressable onPress={() => { previewOrderImages(imageList, index) }}>
                    <Image source={{ uri: image['thumbnailUrl'] ?? image['imageURL'] }}
                        style={[{
                            width: 86, height: 86, borderWidth: 3,
                            borderColor: AppTheme.color.primary, borderRadius: 12
                        }]} />
                </Pressable>
            </View>
        )}
    </ScrollView>)
}

export default OrderImageListView